var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "portal-notice" },
    [
      _c(
        "el-tabs",
        [
          _c("el-tab-pane", { attrs: { label: "公司公告" } }, [
            _c(
              "div",
              { staticClass: "pane-container" },
              [
                _vm._l(_vm.companyNoticeList, function(notice) {
                  return [
                    _c("div", { key: notice.ID, staticClass: "notice-item" }, [
                      _c(
                        "div",
                        {
                          staticClass: "title",
                          on: {
                            click: function($event) {
                              return _vm.openNoticeDialog(notice)
                            }
                          }
                        },
                        [_vm._v(_vm._s(notice.THEME))]
                      ),
                      _c("div", { staticClass: "date" }, [
                        _vm._v(_vm._s(notice.ISSUE_DATE))
                      ])
                    ])
                  ]
                })
              ],
              2
            )
          ]),
          _c("el-tab-pane", { attrs: { label: "供应商须知" } }, [
            _c(
              "div",
              { staticClass: "pane-container" },
              [
                _vm._l(_vm.vendorNoticeList, function(notice) {
                  return [
                    _c("div", { key: notice.ID, staticClass: "notice-item" }, [
                      _c(
                        "div",
                        {
                          staticClass: "title",
                          on: {
                            click: function($event) {
                              return _vm.openNoticeDialog(notice)
                            }
                          }
                        },
                        [_vm._v(_vm._s(notice.THEME))]
                      ),
                      _c("div", { staticClass: "date" }, [
                        _vm._v(_vm._s(notice.ISSUE_DATE))
                      ])
                    ])
                  ]
                })
              ],
              2
            )
          ])
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.noticeDialogVisilble,
            title: _vm.currentNotice.THEME
          },
          on: {
            "update:visible": function($event) {
              _vm.noticeDialogVisilble = $event
            }
          }
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.currentNotice.CONTENT) }
          }),
          _vm.currentNotice.ATTACHMENT_URL && _vm.currentNotice.ATTACHMENT_NAME
            ? _c("div", { staticClass: "attachment" }, [
                _c("span", [_vm._v("附件：")]),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.filePath + _vm.currentNotice.ATTACHMENT_URL,
                      target: "_blank"
                    }
                  },
                  [
                    _vm._v(
                      "《" + _vm._s(_vm.currentNotice.ATTACHMENT_NAME) + "》"
                    )
                  ]
                )
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }